import { Core } from "@faire/slate/foundation/color";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { ILoggedOutHomepageCategoriesResponse } from "@faire/web-api--source/faire/layout/ILoggedOutHomepageCategoriesResponse";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { Typography } from "@faire/web/slate/Typography";
import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";

export const ExploreCategoryCard: React.FC<{
  category: ILoggedOutHomepageCategoriesResponse.ICategoryItem;
  aspectRatio: number;
}> = ({ category, aspectRatio }) => {
  const { isMobile } = useViewport();

  return (
    <Link
      to={category.category_link ?? ""}
      onClick={() => {
        trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick(
          "explore_categories_carousel-cta",
          category.category_link ?? "",
          "v2"
        );
      }}
      className="group relative overflow-hidden transition-transform duration-1000 ease-in-out"
    >
      <div className="relative w-full overflow-hidden transition-transform duration-500 ease-linear">
        <img
          src={category.category_image?.url ?? ""}
          alt={
            category.category_image?.alt_text ?? category.category_name ?? ""
          }
          className="w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.67,0.24,1)] group-hover:scale-110"
          style={{
            aspectRatio,
            borderRadius: "var(--radius-fs-component-default)",
          }}
        />
        <div
          className="absolute inset-0 z-[1]"
          style={{
            background:
              "linear-gradient(22.18deg, rgba(0, 0, 0, 0.5) 1.86%, rgba(0, 0, 0, 0) 31.23%)",
          }}
        />
      </div>
      <div
        className={`absolute bottom-0 left-0 z-[2] ${isMobile ? "pb-2 pl-2" : "p-4"}`}
      >
        <Typography
          variant={{
            mobileAndAbove: "paragraphSansRegular",
            tabletAndAbove: "pageHeaderSerifRegular",
          }}
          color={Core.text.primaryInverse}
        >
          {category.category_name ?? ""}
        </Typography>
      </div>
    </Link>
  );
};
